/* eslint-disable no-underscore-dangle */
var INGEST_EVENT_V1 = 'tracking:event:ingest-api:v1';
var POSTPONED_EVENT = 'tracking:event:postponed';
var GA4_EVENT_PREFIX = 'event:tracking:ga4:';
var PERSISTED_EVENTS = [INGEST_EVENT_V1, POSTPONED_EVENT];
var isBrowser = typeof window !== 'undefined';

var isArray = function (value) {
    return !!value && typeof value === 'object' && value.constructor === Array;
};

var shouldUsePersistenceLayer = function (eventName) {
    const isGA4Event = eventName.startsWith(GA4_EVENT_PREFIX);
    return isBrowser && (PERSISTED_EVENTS.includes(eventName) || isGA4Event);
};

var getFirstStoredEvent = function (name) {
    if (!window.__EventBusStorage) {
        return;
    }
    var events = window.__EventBusStorage[name];
    if (isArray(events) && events.length > 0) {
        return events[0];
    }
};

var triggerEvent = function (callback, thisArg, eventParameters) {
    callback.apply(thisArg, eventParameters);
};

var triggerStoredEvents = function (name, callback, thisArg) {
    if (!window.__EventBusStorage) {
        return;
    }
    var events = window.__EventBusStorage[name];
    if (isArray(events)) {
        events.forEach(function (eventParameters) {
            callback.apply(thisArg, eventParameters);
        });
    }
};

function storeEvent(name, parameters) {
    if (!window.__EventBusStorage) {
        window.__EventBusStorage = {};
    }
    if (isArray(window.__EventBusStorage[name]) === false) {
        window.__EventBusStorage[name] = [];
    }
    window.__EventBusStorage[name].push(parameters);
}

var eventBusWithPersistenceLayer = (function () {
    var defaultBus = require('happened').create({
        scheduler: setImmediate,
    });

    return {
        ALL_EVENTS: defaultBus.ALL_EVENTS,
        off: defaultBus.off,
        trigger: function (name) {
            var parameters = [];
            for (var i = 1; i < arguments.length; ++i) {
                parameters.push(arguments[i]);
            }
            if (shouldUsePersistenceLayer(name)) {
                storeEvent(name, parameters);
            }
            defaultBus.trigger.apply(defaultBus, arguments);
        },
        on: function (name, callback, thisArg) {
            if (shouldUsePersistenceLayer(name)) {
                triggerStoredEvents(name, callback, thisArg);
            }
            defaultBus.on(name, callback, thisArg);
        },
        once: function (name, callback, thisArg) {
            if (shouldUsePersistenceLayer(name)) {
                var eventParameters = getFirstStoredEvent(name);
                if (eventParameters) {
                    triggerEvent(callback, thisArg, eventParameters);
                } else {
                    defaultBus.once(name, callback, thisArg);
                }
            } else {
                defaultBus.once(name, callback, thisArg);
            }
        }
    };
})();

// By default an instance of `happened` is frozen
// So when we are using it as default export
// we are also freezing the export
// so we cannot extend the export unless we proxy all calls to an object which is not frozen
var wrappedHappened = (function() {
    var defaultBus = require('happened').create({
        scheduler: setImmediate,
    });

    return {
        ALL_EVENTS: defaultBus.ALL_EVENTS,
        off: defaultBus.off,
        trigger: defaultBus.trigger,
        on: defaultBus.on,
        once: defaultBus.once,
    };
})();

var exports = module.exports = wrappedHappened;
exports.withPersistanceLayer = eventBusWithPersistenceLayer;